import { type PropsWithChildren, useRef } from 'react';

import { createStore, type Store } from '../../../core/store/store.js';
import { initialState } from '../constants.js';
import { HoneycombStoreContext } from '../context/honeycomb-store.context.js';
import { type HoneycombState } from '../types/state.js';

export const HoneycombStoreProvider = ({ children }: PropsWithChildren) => {
  const storeRef = useRef<Store<HoneycombState> | null>(null);

  storeRef.current = createStore(initialState);

  return (
    <HoneycombStoreContext.Provider value={storeRef.current}>
      {children}
    </HoneycombStoreContext.Provider>
  );
};
